import { useRef, useEffect } from 'react';

// since I need to get and use a dynamic height, this seemed like the best way to set it up
export const useDropDown = ({ expanded }: { expanded: boolean }) => {
  const containerRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const linkRef = useRef() as React.MutableRefObject<HTMLUListElement>;

  useEffect(() => {
    const currentLinkHeight = linkRef.current.getBoundingClientRect().height;

    if (expanded) {
      containerRef.current.style.height = `${currentLinkHeight}px`;
    } else {
      containerRef.current.style.height = `0px`;
    }
  }, [expanded]);

  return {
    containerRef,
    linkRef,
  };
};
